<template>
    <div
        class="Home"
        :class="{ 'Home--desktop': !isMobile }">
        <div
            class="Home-titleWrapper"
            v-routing-animation="{speedModifier: 50}">
            <h1 class="Home-title">{{ title }}</h1>
            <h3
                class="Home-copy"
                v-html="copy"/>
        </div>
        <div class="Home-buttonWrapper">
            <router-link
                :to="{ path: '/find', query: $route.query }"
                @click.native="dataLayerAdd({ type: 'virtualPageview' }, '/find-product/start')"
                class="Home-button"><hempel-button
                    :label="find"
                    primary/></router-link>
            <router-link
                :to="{ path: '/calculate', query: $route.query }"
                @click.native="dataLayerAdd({ type: 'virtualPageview' }, '/calculate-volume/start')"
            ><hempel-button
                :label="calculate"
                primary/></router-link>
        </div>

    </div>
</template>
<script>
import HempelButton from '@/components/shared/button/Button'

export default {
    name: 'Home',
    components: {
        HempelButton
    },
    computed: {
        title() {
            return this.translation.home.title
        },
        copy() {
            return this.translation.home.subtitle
        },
        find() {
            return this.translation.home.findProduct
        },
        calculate() {
            return this.translation.home.calculateVolume
        }
    },
    mounted() {
        const cookies = document.createElement('script')
        cookies.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
        cookies.setAttribute('id', 'Cookiebot')
        cookies.setAttribute('data-cbid', 'bf5aac4a-93b9-4b4d-b40a-b04a78c36b5e')
        cookies.setAttribute('data-blockingmode', 'auto')
        cookies.setAttribute('type', 'text/javascript')
        document.head.appendChild(cookies)
    }
}
</script>
